import Button from "../../components/Button";
import useProjectInfo from "../../hooks/useProjectinfo";
import { useWeb3Context, useAddress } from "../../hooks/web3Context";

const ConnectButton = ({ type, fullWidth }) => {
  const { connect, disconnect } = useWeb3Context();
  const { setNotification } = useProjectInfo();
  const address = useAddress();

  function onConnect() {
    connect().then((msg) => {
      if (msg.type === "error") {
        setNotification(msg);
      }
    });
  }
  let ellipsis = address
    ? (address.slice(0, 7) + "..." + address.substring(address.length - 4)).toUpperCase()
    : "CONNECT WALLET";

  return (
    <>
      {type === "gradient" ? (
        <Button
          type={"default"}
          className="w-[295px] h-[76px] font-bold rounded-[10px] buttonShadow dark:bg-[linear-gradient(200deg,#FFF,#FFF,#FFF,#1F2399)] bg-[linear-gradient(200deg,#FFF,#FFF,#FFF,#049047)] text-white tracking-[0.75px] leading-[1] bg-[length:700%_100%] hover:bg-[100%_0] dark:hover:text-secondary hover:text-green duration-500"
          onClick={() => (address ? disconnect() : onConnect())}
        >
          {ellipsis}
        </Button>
      ) : (
        <Button
          type={"default"}
          className="w-[215px] h-[55px] font-bold rounded-[10px] text-[15px] tracking-[0.75px] leading-[1] bg-white text-primary hover:bg-primary hover:text-white duration-150 buttonShadow"
          onClick={() => (address ? disconnect() : onConnect())}
        >
          {ellipsis}
        </Button>
      )}
    </>
  );
};

export default ConnectButton;
